<aside class="sidebar">
  <nav class="navigation">
    <div class="navigation__logo">
      <img class="logo--large" src="assets/logo.svg" alt="Heorot Logo" />
      <img class="logo--small" src="assets/small-logo.svg" alt="Heorot Logo" />
    </div>

    <div class="navigation__links">
      <li
        class="navbar__menu-item"
        routerLinkActive="active"
        #dashboardRla="routerLinkActive"
        [class.active]="dashboardRla.isActive"
        [routerLinkActiveOptions]="routeMatchOptions"
      >
        <a
          [routerLink]="dashboardUrl"
          [attr.aria-label]="'Navigation.Dashboard' | translate"
        >
          <i class="ph ph-chart-line ph-bold"></i>
          <span class="link-text">{{ 'Navigation.Dashboard' | translate }}</span>
        </a>
      </li>
    </div>

    <div class="seperator"></div>

    <div class="navigation__links">
      <li
        class="navbar__menu-item"
        routerLinkActive="active"
        #planningRla="routerLinkActive"
        [class.active]="planningRla.isActive"
        [routerLinkActiveOptions]="routeMatchOptions"
      >
        <a
          [routerLink]="planningUrl"
          [attr.aria-label]="'Navigation.Planning' | translate"
        >
          <i class="ph ph-calendar-blank ph-bold"></i>
          <span class="link-text">{{ 'Navigation.Planning' | translate }}</span>
        </a>
      </li>

      <li
        class="navbar__menu-item"
        routerLinkActive="active"
        #resultsRla="routerLinkActive"
        [class.active]="resultsRla.isActive"
        [routerLinkActiveOptions]="routeMatchOptions"
      >
        <a
          [routerLink]="planningAndResultsUrl"
          [attr.aria-label]="'Navigation.PlanningAndResults' | translate"
        >
          <i class="ph ph-chart-bar ph-bold"></i>
          <span class="link-text">{{ 'Navigation.PlanningAndResults' | translate }}</span>
        </a>
      </li>
    </div>

    <div class="seperator"></div>

    <!-- Temporary comment Settings until feature is ready -->

    <div class="navigation__links">
      <li
        class="navbar__menu-item"
        routerLinkActive="active"
        #settingsRla="routerLinkActive"
        [class.active]="settingsRla.isActive"
        [routerLinkActiveOptions]="routeMatchOptions"
      >
        <a
          [routerLink]="settingsUrl"
          [attr.aria-label]="'Navigation.Settings' | translate"
        >
          <i class="ph ph-gear-six ph-bold"></i>
          <span class="link-text">{{ 'Navigation.Settings' | translate }}</span>
        </a>
      </li>
    </div>
  </nav>
  <div class="action-bar">
    <button
      #lexipoortBtn
      class="action-bar__item"
      (click)="lexipoortMenu.toggle($event)"
      [attr.aria-label]="'Lexipoort'"
    >
      <div class="icon-with-text">
        <img src="assets/allkind.svg" />
        <span class="action-text">Lexipoort</span>
      </div>
      <i class="ph ph-caret-right ph-bold"></i>
    </button>
    <button class="action-bar__item" (click)="showChangelog()" id="changelog">
      <div class="icon-with-text">
        <i class="ph ph-bold ph-notepad"></i>
        <span class="action-text">{{ 'Navigation.LastUpdates' | translate }}</span>
      </div>
    </button>
    <button
      #languageBtn
      class="action-bar__item"
      (click)="languageMenu.toggle($event)"
      [attr.aria-label]="currentLanguageLabel()"
    >
      <div class="icon-with-text">
        <i class="ph ph-translate ph-bold"></i>
        <span class="action-text">{{ currentLanguageLabel() }}</span>
      </div>
      <i class="ph ph-caret-right ph-bold"></i>
    </button>
    <button
      #helpBtn
      class="action-bar__item"
      (click)="helpMenu.toggle($event)"
      [attr.aria-label]="'Navigation.Help' | translate"
    >
      <div class="icon-with-text">
        <i class="ph ph-question ph-bold"></i>
        <span class="action-text">{{ 'Navigation.Help' | translate }}</span>
      </div>
      <i class="ph ph-caret-right ph-bold"></i>
    </button>
    @if (isAuthenticated()) {
      <button
        class="action-bar__item"
        (click)="logout()"
        [attr.aria-label]="'SideBar.Logout' | translate"
      >
        <div class="icon-with-text">
          <i class="ph ph-sign-out ph-bold"></i>
          <span class="action-text">{{ 'SideBar.Logout' | translate }}</span>
        </div>
      </button>
      <div class="action-bar__item user-profile">
        <p-avatar
          [label]="initials()"
          styleClass="mr-2 user-profile__avatar"
          size="large"
          [style]="{ 'background-color': '#1d6daa', color: '#ffffff','border-radius': '16px', 'font-size': '16px', 'line-height': '1' }"
        />
        <div class="user-profile__info">
          <h4>{{ firstName() }}</h4>
          <h4>{{ lastNameWithPrefix() }}</h4>
        </div>
      </div>
    } @else {
      <button
        class="action-bar__item"
        (click)="login()"
        [attr.aria-label]="'SideBar.Login' | translate"
      >
        <div class="icon-with-text">
          <i class="ph ph-sign-in ph-bold"></i>
          <span class="action-text">{{ 'SideBar.Login' | translate }}</span>
        </div>
      </button>
    }
  </div>
</aside>

<p-menu
  #languageMenu
  [popup]="true"
  [model]="languageItems"
  appendTo="body"
  styleClass="language-dropdown-menu"
  (onShow)="positionMenu(languageBtn, '.language-dropdown-menu')"
>
</p-menu>

<p-menu
  #helpMenu
  [popup]="true"
  [model]="helpItems"
  appendTo="body"
  styleClass="help-dropdown-menu"
  (onShow)="positionMenu(helpBtn, '.help-dropdown-menu')"
>
</p-menu>

<p-menu
  #lexipoortMenu
  [popup]="true"
  [model]="lexipoortItems"
  appendTo="body"
  styleClass="lexipoort-dropdown-menu"
  (onShow)="positionMenu(lexipoortBtn, '.lexipoort-dropdown-menu')"
>
</p-menu>
